import { DASHCOLORS } from 'bd-web-components'
import styled, { css } from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 1325px;
  margin: 0 auto;
  margin-bottom: 162px;
  padding: 0px 64px;
  justify-content: flex-start;
  @media (max-width: 768px) {
    padding: 0px 24px;
  }
`
// header divs -------------------

export const PageHeaderBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  width: 100%;
  height: 120px;
  @media (max-width: 768px) {
    height: 160px;
    flex-direction: column;
    align-items: flex-start;
    max-width: 100%;
  }
`
export const TextHeaderBox = styled.div`
  width: 70%;
  @media (max-width: 768px) {
    width: 100%;
  }
`

export const ButtonHeaderBox = styled.div`
  width: 30%;
  display: flex;
  justify-content: flex-end;
  @media (max-width: 768px) {
    margin-top: 20px;
    width: 100%;
    max-width: 100%;
    justify-content: flex-start;
  }
`

// header text and button -------------------
export const PageTitle = styled.h4`
  color: ${DASHCOLORS.PRIMARY_BLUE_02};
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 35.2px;
  margin-top: 40px;
  margin-bottom: 19px;
  @media (max-width: 768px) {
    font-size: 20px;
    font-style: normal;
    font-weight: 600;
    line-height: 22px;
    margin-top: 27px;
    margin-bottom: 13px;
  }
`
export const PageSubtitle = styled.p`
  color: ${DASHCOLORS.GRAY_SCALE_05};
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  @media (max-width: 768px) {
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 18px;
  }
`

// Page Divider -------------------------------

export const FormDivider = styled.div`
  background-color: ${DASHCOLORS.GRAY_SCALE_08};
  width: 100%;
  height: 2px;
  margin-top: 29px;
  margin-bottom: 24px;
  @media (max-width: 768px) {
    margin-top: 29px;
    margin-bottom: 24px;
  }
`

// Exception Container -------------------------------

interface ExceptionContainerProps {
  height: number
  margin: boolean
}

export const ExceptionContainer = styled(styled.div``)<ExceptionContainerProps>`
  display: flex;
  justify-content: center;
  align-items: center;

  ${(props) =>
    props.height !== undefined &&
    css`
      height: ${props.height}px;
    `}
  ${(props) =>
    props.margin &&
    css`
      margin-bottom: 100px;
    `}
`

// Table Container -------------------------------

export const TableContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-x: auto;
  padding: 10px;
  list-style: none;
  li::marker {
    content: none;
  }
`
